<template>
  <div class="ma-4">
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />
    <div class="text-h4 mb-4" v-show="!showSkeleton">Atualizar Pausa - {{ description }}</div>

    <div v-if="canRender">
      <CadastroPausa edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import pausasStore from '../_store'

import CadastroPausa from './CadastroPausa'

export default {
  name: 'AtualizarRamais',
  props: {
    _id: String,
  },
  components: { CadastroPausa, SkeletonLoaderTitleUpdate },
  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),
  computed: {
    ...mapGetters('atualizarPausaModuleCallCenterStore', ['getPausa']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarPausaModuleCallCenterStore', pausasStore)
    await this.listarPausaEspecifica(this._id)
    this.description = this.getPausa.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarPausaModuleCallCenterStore', ['listarPausaEspecifica']),
  },
}
</script>
